import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

const FAQ = ({ faqData= [] }) => {
  const [openItems, setOpenItems] = useState({});

  const toggleItem = (id) => {
    setOpenItems((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  return (
    <div className="w-full min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12 lg:py-16">
        <div className="text-center mb-8 sm:mb-12 lg:mb-16">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-gray-900 mb-3 sm:mb-4 lg:mb-6">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="grid gap-3 sm:gap-4 lg:gap-6 max-w-4xl mx-auto">
          {faqData?.map((item) => (
            <div
              key={item.id}
              className="bg-white border border-gray-200 rounded-lg sm:rounded-xl shadow-sm hover:shadow-md transition-all duration-300 hover:border-gray-300"
            >
              <button
                onClick={() => toggleItem(item.id)}
                className="w-full px-4 sm:px-6 lg:px-8 py-4 sm:py-5 lg:py-6 text-left focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded-lg sm:rounded-xl"
              >
                <div className="flex justify-between items-start sm:items-center gap-3 sm:gap-4">
                  <h3 className="text-sm sm:text-base lg:text-lg xl:text-xl font-semibold text-gray-900 leading-tight sm:leading-normal">
                    {item.question}
                  </h3>
                  <div className="flex-shrink-0 mt-1 sm:mt-0">
                    {openItems[item.id] ? (
                      <ChevronUp className="w-4 h-4 sm:w-5 sm:h-5 lg:w-6 lg:h-6 text-gray-500 transition-transform duration-300" />
                    ) : (
                      <ChevronDown className="w-4 h-4 sm:w-5 sm:h-5 lg:w-6 lg:h-6 text-gray-500 transition-transform duration-300" />
                    )}
                  </div>
                </div>
              </button>

              <div
                className={`overflow-hidden transition-all duration-500 ease-in-out ${
                  openItems[item.id]
                    ? "max-h-screen opacity-100"
                    : "max-h-0 opacity-0"
                }`}
              >
                <div className="px-4 sm:px-6 lg:px-8 pb-4 sm:pb-5 lg:pb-6">
                  <div className="pt-2 sm:pt-3 border-t border-gray-100">
                    <p className="text-sm sm:text-base lg:text-lg text-gray-700 leading-relaxed mt-2 sm:mt-3">
                      {item.answer}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;
